import { ProductEnum } from './ProductEnum';

const GroupNames = {
  Serve: 'Serve',
  Students: 'Students',
};

export const AccessInfoEnum = {
  PointOfSale: {
    Id: 35,
    ProductId: ProductEnum.PointOfSale,
    GroupName: GroupNames.Serve,
  },
  ManageApplication: {
    Id: 106,
    ProductId: ProductEnum.PointOfSale,
    GroupName: GroupNames.Students,
  },
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/AccessInfoEnum.js